export default {
  // Common translations
  'common.cancel': '取消',
  'common.confirm': '确认',
  'common.save': '保存',
  'common.delete': '删除',
  'common.edit': '编辑',
  'common.add': '添加',
  'common.search': '搜索',
  'common.reset': '重置',
  'common.submit': '提交',
  'common.close': '关闭',

  'pages.layouts.userLayout.title': 'Ant Design 是西湖区最具影响力的 Web 设计规范',
  'pages.login.accountLogin.tab': '账户密码登录',
  'pages.login.accountLogin.errorMessage': '错误的用户名和密码(admin/ant.design)',
  'pages.login.failure': '登录失败，请重试！',
  'pages.login.success': '登录成功！',
  'pages.login.username.placeholder': '用户名: admin or user',
  'pages.login.username.required': '用户名是必填项！',
  'pages.login.password.placeholder': '密码: ant.design',
  'pages.login.password.required': '密码是必填项！',
  'pages.login.phoneLogin.tab': '手机号登录',
  'pages.login.phoneLogin.errorMessage': '验证码错误',
  'pages.login.phoneNumber.placeholder': '请输入手机号！',
  'pages.login.phoneNumber.required': '手机号是必填项！',
  'pages.login.phoneNumber.invalid': '不合法的手机号！',
  'pages.login.captcha.placeholder': '请输入验证码！',
  'pages.login.captcha.required': '验证码是必填项！',
  'pages.login.phoneLogin.getVerificationCode': '获取验证码',
  'pages.getCaptchaSecondText': '秒后重新获取',
  'pages.login.rememberMe': '自动登录',
  'pages.login.forgotPassword': '忘记密码 ?',
  'pages.login.submit': '登录',
  'pages.login.loginWith': '其他登录方式 :',
  'pages.login.registerAccount': '注册账户',
  'pages.welcome.link': '欢迎使用',
  'pages.welcome.alertMessage': '更快更强的重型组件，已经发布。',
  'pages.404.subTitle': '抱歉，您访问的页面不存在。',
  'pages.404.buttonText': '返回首页',
  'pages.admin.subPage.title': ' 这个页面只有 admin 权限才能查看',
  'pages.admin.subPage.alertMessage': 'umi ui 现已发布，欢迎使用 npm run ui 启动体验。',
  'pages.searchTable.createForm.newRule': '新建规则',
  'pages.searchTable.updateForm.ruleConfig': '规则配置',
  'pages.searchTable.updateForm.basicConfig': '基本信息',
  'pages.searchTable.updateForm.ruleName.nameLabel': '规则名称',
  'pages.searchTable.updateForm.ruleName.nameRules': '请输入规则名称！',
  'pages.searchTable.updateForm.ruleDesc.descLabel': '规则描述',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': '请输入至少五个字符',
  'pages.searchTable.updateForm.ruleDesc.descRules': '请输入至少五个字符的规则描述！',
  'pages.searchTable.updateForm.ruleProps.title': '配置规则属性',
  'pages.searchTable.updateForm.object': '监控对象',
  'pages.searchTable.updateForm.ruleProps.templateLabel': '规则模板',
  'pages.searchTable.updateForm.ruleProps.typeLabel': '规则类型',
  'pages.searchTable.updateForm.schedulingPeriod.title': '设定调度周期',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '开始时间',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': '请选择开始时间！',
  'pages.searchTable.titleDesc': '描述',
  'pages.searchTable.ruleName': '规则名称为必填项',
  'pages.searchTable.titleCallNo': '服务调用次数',
  'pages.searchTable.titleStatus': '状态',
  'pages.searchTable.nameStatus.default': '关闭',
  'pages.searchTable.nameStatus.running': '运行中',
  'pages.searchTable.nameStatus.online': '已上线',
  'pages.searchTable.nameStatus.abnormal': '异常',
  'pages.searchTable.titleUpdatedAt': '上次调度时间',
  'pages.searchTable.exception': '请输入异常原因！',
  'pages.searchTable.titleOption': '操作',
  'pages.searchTable.config': '配置',
  'pages.searchTable.subscribeAlert': '订阅警报',
  'pages.searchTable.title': '查询表格',
  'pages.searchTable.new': '新建',
  'pages.searchTable.chosen': '已选择',
  'pages.searchTable.item': '项',
  'pages.searchTable.totalServiceCalls': '服务调用次数总计',
  'pages.searchTable.tenThousand': '万',
  'pages.searchTable.batchDeletion': '批量删除',
  'pages.searchTable.batchApproval': '批量审批',
  // Staff Management
  'pages.staffManagement.title': '员工管理',
  'pages.staffManagement.staffList': '员工列表',
  'pages.staffManagement.addStaff': '添加员工',
  'pages.staffManagement.editStaff': '编辑员工',
  'pages.staffManagement.exportExcel': '导出Excel',
  'pages.staffManagement.exportTooltip': '导出员工数据到Excel（CSV格式，UTF-8编码）',
  'pages.staffManagement.exportSuccess':
    '员工列表导出成功！为获得最佳中文字符显示效果，请在Excel中打开并确保选择UTF-8编码。',
  'pages.staffManagement.staffCreated': '员工创建成功！',
  'pages.staffManagement.staffUpdated': '员工更新成功！',
  'pages.staffManagement.staffDeleted': '员工删除成功！',
  'pages.staffManagement.deleteFailed': '删除员工失败',
  'pages.staffManagement.deleteStaff': '删除员工',
  'pages.staffManagement.deleteConfirmTitle': '删除员工',
  'pages.staffManagement.deleteConfirmDescription': '确定要删除 {name} 吗？此操作无法撤销。',
  'pages.staffManagement.deleteConfirm': '是',
  'pages.staffManagement.deleteCancel': '否',
  'pages.staffManagement.viewAssignments': '查看员工排班',
  'pages.staffManagement.operationFailed': '操作失败',
  'pages.staffManagement.accessDenied': '访问被拒绝',
  // Staff Form Fields
  'pages.staffManagement.employeeId': '员工编号',
  'pages.staffManagement.employeeIdPlaceholder': '搜索员工编号',
  'pages.staffManagement.employeeIdRequired': '请输入员工编号',
  'pages.staffManagement.firstName': '名字',
  'pages.staffManagement.firstNamePlaceholder': '搜索名字',
  'pages.staffManagement.firstNameRequired': '请输入名字',
  'pages.staffManagement.lastName': '姓氏',
  'pages.staffManagement.lastNamePlaceholder': '搜索姓氏',
  'pages.staffManagement.lastNameRequired': '请输入姓氏',
  // Transaction Categories
  'transaction.category.income': '收入',
  'transaction.category.expenses': '支出',
  'transaction.category.investmentIncome': '投资收益',
  'transaction.category.interest': '利息',
  'transaction.category.capitalGains': '资本收益',
  'transaction.category.dividends': '股息',
  'transaction.category.rentIncome': '租金收入',
  'transaction.category.equipmentRental': '设备租赁',
  'transaction.category.residentialRent': '住宅租金',
  'transaction.category.commercialRent': '商业租金',
  'transaction.category.otherIncome': '其他收入',
  'transaction.category.donationsReceived': '收到的捐赠',
  'transaction.category.grants': '补助金',
  'transaction.category.miscellaneousIncome': '杂项收入',
  'transaction.category.royalties': '版税',
  'transaction.category.sales': '销售',
  'transaction.category.productSales': '产品销售',
  'transaction.category.onlineSales': '在线销售',
  'transaction.category.serviceSales': '服务销售',
  'transaction.category.wholesaleSales': '批发销售',
  'transaction.category.operatingExpenses': '运营费用',
  'transaction.category.rent': '租金',
  'transaction.category.officeRent': '办公室租金',
  'transaction.category.warehouseRent': '仓库租金',
  'transaction.category.equipmentLease': '设备租赁',
  'transaction.category.salariesWages': '工资薪金',
  'transaction.category.fullTimeEmployees': '全职员工',
  'transaction.category.contractors': '承包商',
  'transaction.category.partTimeEmployees': '兼职员工',
  'transaction.category.advertisingMarketing': '广告营销',
  'transaction.category.digitalAdvertising': '数字广告',
  'transaction.category.eventSponsorships': '活动赞助',
  'transaction.category.printAdvertising': '印刷广告',
  'transaction.category.financialExpenses': '财务费用',
  'transaction.category.loanInterest': '贷款利息',
  'transaction.category.creditCardCharges': '信用卡费用',
  'transaction.category.bankFees': '银行费用',
  'transaction.category.depreciationAmortization': '折旧摊销',
  'transaction.category.equipmentDepreciation': '设备折旧',
  'transaction.category.buildingDepreciation': '建筑折旧',
  'transaction.category.otherExpenses': '其他费用',
  'transaction.category.taxes': '税费',
  'transaction.category.salesTax': '销售税',
  'transaction.category.incomeTax': '所得税',
  'transaction.category.propertyTax': '房产税',
  'transaction.category.miscellaneousExpenses': '杂项费用',
  'transaction.category.repairsMaintenance': '维修保养',
  'transaction.category.administrativeExpenses': '行政费用',
  'transaction.category.officeSupplies': '办公用品',
  'transaction.category.utilities': '公用事业',
  'transaction.category.internetPhone': '网络电话',
  'transaction.category.electricity': '电力',
  'transaction.category.water': '水费',
  'transaction.category.professionalFees': '专业费用',
  'transaction.category.accountingFees': '会计费用',
  'transaction.category.legalFees': '法律费用',
  'pages.staffManagement.name': '姓名',
  'pages.staffManagement.staffTitle': '称谓',
  'pages.staffManagement.titlePlaceholder': '选择称谓',
  'pages.staffManagement.gender': '性别',
  'pages.staffManagement.genderPlaceholder': '选择性别',
  'pages.staffManagement.male': '男',
  'pages.staffManagement.female': '女',
  'pages.staffManagement.other': '其他',
  'pages.staffManagement.phone': '电话',
  'pages.staffManagement.phonePlaceholder': '搜索电话',
  'pages.staffManagement.hkidNumber': '香港身份证号码',
  'pages.staffManagement.hkidNumberPlaceholder': '搜索香港身份证',
  'pages.staffManagement.age': '年龄',
  'pages.staffManagement.securityLicense': '保安牌照',
  'pages.staffManagement.securityLicensePlaceholder': '搜索牌照',
  'pages.staffManagement.securityLicenseNumber': '保安牌照号码',
  'pages.staffManagement.securityLicenseAExpiry': '保安牌照A到期日',
  'pages.staffManagement.securityLicenseBExpiry': '保安牌照B到期日',
  'pages.staffManagement.qasCertificateIssueDate': 'QAS证书签发日期',
  'pages.staffManagement.medicalReportIssueDate': '体检报告签发日期（65岁以上）',
  'pages.staffManagement.employmentStatus': '雇佣状态',
  'pages.staffManagement.employmentStatusPlaceholder': '选择状态',
  'pages.staffManagement.contractType': '合同类型',
  'pages.staffManagement.contractTypePlaceholder': '选择合同类型',
  'pages.staffManagement.contractTypeDescription': '合同类型描述',
  'pages.staffManagement.contractType.permanent': '长期（无固定期限）劳动合同',
  'pages.staffManagement.contractType.fixed_term': '固定期限劳动合同',
  'pages.staffManagement.contractType.temporary': '临时劳动合同',
  'pages.staffManagement.contractType.part_time': '兼职劳动合同',
  'pages.staffManagement.contractType.casual': '零工劳动合同',

  // Site Gate Management
  'siteDetail.gateManagementTitle': '门禁管理',
  'siteDetail.addGate': '添加门禁',
  'siteDetail.editGate': '编辑门禁',
  'siteDetail.deleteGate': '删除门禁',
  'siteDetail.gateName': '门禁名称',
  'siteDetail.gateType': '门禁类型',
  'siteDetail.passcode': '门禁密码',
  'siteDetail.gateType.main': '主门',
  'siteDetail.gateType.service': '服务门',
  'siteDetail.gateType.emergency': '紧急门',
  'siteDetail.gateType.pedestrian': '人行门',
  'siteDetail.gateType.vehicle': '车辆门',
  'siteDetail.gateCreated': '门禁创建成功！',
  'siteDetail.gateUpdated': '门禁更新成功！',
  'siteDetail.gateDeleted': '门禁删除成功！',
  'siteDetail.gateDeleteFailed': '删除门禁失败',
  'siteDetail.gateOperationFailed': '门禁操作失败',
  'siteDetail.deleteGateConfirmTitle': '删除门禁',
  'siteDetail.deleteGateConfirmDescription': '确定要删除此门禁吗？此操作无法撤销。',
  'siteDetail.deleteGateConfirm': '是',
  'siteDetail.deleteGateCancel': '否',
  'siteDetail.gateNameRequired': '请输入门禁名称',
  'siteDetail.gateTypeRequired': '请选择门禁类型',

  // Shift Assignment Import
  'shiftAssignment.clearAndReplaceMode': '清除并替换模式',
  'shiftAssignment.clearAndReplaceDescription':
    '在导入新数据之前，已清除本月的现有排班和请假记录。',
  'shiftAssignment.clearedData': '已清除数据',
  'shiftAssignment.clearedAssignments': '已清除排班',
  'shiftAssignment.clearedLeaves': '已清除请假',
  'shiftAssignment.assignments': '排班',
  'shiftAssignment.leaves': '请假',
  'shiftAssignment.totalLeaves': '总请假数',
  'shiftAssignment.createdLeaves': '已创建请假',
  'shiftAssignment.skippedLeaves': '已跳过请假',
  'shiftAssignment.totalConflicts': '总冲突数',

  // Shift Assignment Export
  'shiftAssignment.exportExcel': '导出Excel',
  'shiftAssignment.exportSuccess': '导出成功',
  'shiftAssignment.exportError': '导出失败',
  'shiftAssignment.siteName': '站点名称',
  'shiftAssignment.shiftName': '班次名称',
  'shiftAssignment.timeRange': '时间范围',
  'shiftAssignment.region': '区域',
  'shiftAssignment.district': '地区',
  'shiftAssignment.fileTooLarge': '文件必须小于50MB！',
  'shiftAssignment.fileRequirements': '支持 .xlsx 和 .xls 文件，最大50MB',

  // Shift Assignment Import Conflicts
  'shiftAssignment.conflictsReportTitle': '导入冲突报告',
  'shiftAssignment.conflictsReportGenerated': '生成时间',
  'shiftAssignment.conflictNumber': '冲突 #{number}',
  'shiftAssignment.conflictType': '类型',
  'shiftAssignment.conflictDescription': '描述',
  'shiftAssignment.downloadConflicts': '下载冲突报告',
  'shiftAssignment.conflictsDownloaded': '冲突报告已下载',

  // Shift Assignment Staffing Issues Export
  'shiftAssignment.exportIssues': '导出问题',
  'shiftAssignment.staffingIssuesReportTitle': '人员配置问题报告',
  'shiftAssignment.reportPeriod': '报告期间',
  'shiftAssignment.totalIssues': '发现问题总数：{count}',
  'shiftAssignment.issueNumber': '问题 #{number}',
  'shiftAssignment.issueType': '问题类型',
  'shiftAssignment.staffingLevel': '人员配置水平',
  'shiftAssignment.overstaffed': '人员过剩',
  'shiftAssignment.understaffed': '人员不足',
  'shiftAssignment.criticallyUnderstaffed': '严重人员不足',
  'shiftAssignment.severityWarning': '警告',
  'shiftAssignment.severityCritical': '严重',
  'shiftAssignment.severityHigh': '高',
  'shiftAssignment.noIssuesFound': '未发现人员配置问题。所有班次人员配置正常。',
  'shiftAssignment.issuesExported': '人员配置问题报告已导出',

  // Additional Shift Assignment keys
  'shiftAssignment.siteShift': '站点 - 班次',
  'shiftAssignment.sunday': '周日',
  'shiftAssignment.originalName': '原始名称',
  'shiftAssignment.monthPicker': '选择月份',
  'shiftAssignment.filterByRegion': '按区域筛选',
  'shiftAssignment.filterByDistrict': '按地区筛选',
  'shiftAssignment.filterBySite': '按站点筛选',
  'shiftAssignment.legend': '图例',
  'shiftAssignment.holidayName': '节假日名称',
  'shiftAssignment.noSites': '未找到站点',
  'shiftAssignment.import': '导入',
  'shiftAssignment.selectFile': '选择Excel文件',
  'shiftAssignment.importResult': '导入结果',
  'shiftAssignment.totalAssignments': '总排班数',
  'shiftAssignment.createdAssignments': '已创建排班',
  'shiftAssignment.skippedAssignments': '已跳过排班',
  'shiftAssignment.conflicts': '冲突',
  'shiftAssignment.conflictDetails': '冲突详情',
  'shiftAssignment.staff': '员工',
  'shiftAssignment.site': '站点',
  'shiftAssignment.shift': '班次',
  'shiftAssignment.date': '日期',
  'shiftAssignment.importSuccess': '导入成功',
  'shiftAssignment.importWithConflicts': '导入完成，但有冲突',
  'shiftAssignment.importError': '导入失败',
  'shiftAssignment.invalidFileType': '只能上传Excel文件！',
  'shiftAssignment.noFileSelected': '请选择要导入的文件',

  // Shift Detail
  'shiftDetail.updateLeave': '更新请假',
  'shiftDetail.deleteLeave': '删除请假',
  'shiftDetail.sunday': '周日',
  'shiftDetail.backToShiftAssignment': '返回排班管理',
  'shiftDetail.legend': '图例',
  'shiftDetail.holiday': '节假日',
  'shiftDetail.regularDay': '工作日',
  'shiftDetail.statutoryHoliday': '法定节假日',
  'shiftDetail.noPayLeave': '无薪假',
  'shiftDetail.regularHoliday': '常规假期',
  'shiftDetail.compensationLeave': '补假',
  'shiftDetail.absenceWithoutLeave': '旷工',
  'shiftDetail.unpaidSickLeave': '无薪病假',

  'pages.staffManagement.employmentStartDate': '雇佣开始日期',
  'pages.staffManagement.employmentEndDate': '雇佣结束日期',
  'pages.staffManagement.employmentStartRange': '雇佣开始日期范围',
  'pages.staffManagement.licenseAExpiryRange': '牌照A到期日期范围',
  'pages.staffManagement.site': '工作地点',
  'pages.staffManagement.sitePlaceholder': '按工作地点筛选',
  'pages.staffManagement.address': '地址',
  'pages.staffManagement.emergencyContact': '紧急联系人',
  'pages.staffManagement.emergencyPhone': '紧急联系电话',
  'pages.staffManagement.email': '邮箱',
  'pages.staffManagement.emailInvalid': '请输入有效的邮箱地址',
  'pages.staffManagement.password': '密码',
  'pages.staffManagement.active': '激活',
  'pages.staffManagement.inactive': '未激活',
  'pages.staffManagement.status': '状态',
  'pages.staffManagement.createdAt': '创建时间',
  'pages.staffManagement.updatedAt': '更新时间',
  // Employment Status
  'pages.staffManagement.statusActive': '在职',
  'pages.staffManagement.statusResigned': '已辞职',
  'pages.staffManagement.statusTerminated': '已终止',
  // Date Placeholders
  'pages.staffManagement.startDate': '开始日期',
  'pages.staffManagement.endDate': '结束日期',
  'pages.staffManagement.dateOfBirth': '出生日期',
  // Site Notice Management
  'pages.siteNoticeManagement.pageTitle': '物業通知',
  'pages.siteNoticeManagement.noticeList': '通知列表',
  'pages.siteNoticeManagement.addNotice': '添加通知',
  'pages.siteNoticeManagement.editNotice': '编辑通知',
  'pages.siteNoticeManagement.deleteNotice': '删除通知',
  'pages.siteNoticeManagement.noticeCreated': '通知创建成功！',
  'pages.siteNoticeManagement.noticeUpdated': '通知更新成功！',
  'pages.siteNoticeManagement.noticeDeleted': '通知删除成功！',
  'pages.siteNoticeManagement.operationFailed': '操作失败',
  'pages.siteNoticeManagement.confirmDelete': '确定要删除这个通知吗？',
  'pages.siteNoticeManagement.confirmDeleteTitle': '删除通知',
  // Site Notice Form Fields
  'pages.siteNoticeManagement.title': '标题',
  'pages.siteNoticeManagement.titlePlaceholder': '输入通知标题',
  'pages.siteNoticeManagement.titleRequired': '请输入通知标题',
  'pages.siteNoticeManagement.content': '内容',
  'pages.siteNoticeManagement.contentPlaceholder': '输入通知内容',
  'pages.siteNoticeManagement.contentRequired': '请输入通知内容',
  'pages.siteNoticeManagement.site': '物業',
  'pages.siteNoticeManagement.sitePlaceholder': '选择物業',
  'pages.siteNoticeManagement.siteRequired': '请选择一个物業',
  'pages.siteNoticeManagement.priority': '优先级',
  'pages.siteNoticeManagement.priorityPlaceholder': '选择优先级',
  'pages.siteNoticeManagement.priorityLow': '低',
  'pages.siteNoticeManagement.priorityNormal': '普通',
  'pages.siteNoticeManagement.priorityHigh': '高',
  'pages.siteNoticeManagement.priorityUrgent': '紧急',
  'pages.siteNoticeManagement.isPublished': '已发布',
  'pages.siteNoticeManagement.isActive': '激活',
  'pages.siteNoticeManagement.expiresAt': '过期时间',
  'pages.siteNoticeManagement.expiresAtPlaceholder': '选择过期日期',
  'pages.siteNoticeManagement.attachments': '附件',
  'pages.siteNoticeManagement.addAttachment': '添加附件',
  'pages.siteNoticeManagement.removeAttachment': '移除附件',
  'pages.siteNoticeManagement.noAttachments': '无附件',
  // Site Notice Table Columns
  'pages.siteNoticeManagement.columnTitle': '标题',
  'pages.siteNoticeManagement.columnSite': '物業',
  'pages.siteNoticeManagement.columnPriority': '优先级',
  'pages.siteNoticeManagement.columnStatus': '状态',
  'pages.siteNoticeManagement.columnPublished': '发布状态',
  'pages.siteNoticeManagement.columnCreatedBy': '创建者',
  'pages.siteNoticeManagement.columnCreatedAt': '创建时间',
  'pages.siteNoticeManagement.columnExpiresAt': '过期时间',
  'pages.siteNoticeManagement.columnActions': '操作',
  // Site Notice Status
  'pages.siteNoticeManagement.statusPublished': '已发布',
  'pages.siteNoticeManagement.statusDraft': '草稿',
  'pages.siteNoticeManagement.statusActive': '激活',
  'pages.siteNoticeManagement.statusInactive': '未激活',
  'pages.siteNoticeManagement.statusExpired': '已过期',
  // Site Notice Priority Colors
  'pages.siteNoticeManagement.priorityColorLow': 'blue',
  'pages.siteNoticeManagement.priorityColorNormal': 'green',
  'pages.siteNoticeManagement.priorityColorHigh': 'orange',
  'pages.siteNoticeManagement.priorityColorUrgent': 'red',
  // Site Document Management
  'pages.siteDetail.siteDocuments': '物業文档',
  'pages.siteDetail.siteDocuments.create': '上传文档',
  'pages.siteDetail.siteDocuments.edit': '编辑文档',
  'pages.siteDetail.siteDocuments.title': '标题',
  'pages.siteDetail.siteDocuments.description': '描述',
  'pages.siteDetail.siteDocuments.documentType': '文档类型',
  'pages.siteDetail.siteDocuments.file': '文件',
  'pages.siteDetail.siteDocuments.fileOptional': '可选：您可以为本文档添加文件附件',
  'pages.siteDetail.siteDocuments.expiryDays': '过期天数',
  'pages.siteDetail.siteDocuments.expiryDate': '过期日期',
  'pages.siteDetail.siteDocuments.expiryDatePlaceholder': '选择过期日期和时间（可选）',
  'pages.siteDetail.siteDocuments.isActive': '激活',
  'pages.siteDetail.siteDocuments.isPublic': '公开',
  'pages.siteDetail.siteDocuments.isExpired': '已过期',
  'pages.siteDetail.siteDocuments.daysUntilExpiry': '距离过期天数',
  'pages.siteDetail.siteDocuments.isExpiringSoon': '即将过期',
  'pages.siteDetail.siteDocuments.createdBy': '创建者',
  'pages.siteDetail.siteDocuments.createdAt': '创建时间',
  'pages.siteDetail.siteDocuments.actions': '操作',
  'pages.siteDetail.siteDocuments.download': '下载',
  'pages.siteDetail.siteDocuments.removeAttachment': '移除附件',
  'pages.siteDetail.siteDocuments.replaceAttachment': '替换附件',
  'pages.siteDetail.siteDocuments.newFileSelected': '已选择新文件',
  'pages.siteDetail.siteDocuments.attachmentRemoved': '附件移除成功',
  'pages.siteDetail.siteDocuments.attachmentReplaced': '附件替换成功',
  'pages.siteDetail.siteDocuments.actions.edit': '编辑',
  'pages.siteDetail.siteDocuments.actions.delete': '删除',
  'pages.siteDetail.siteDocuments.actions.download': '下载',
  'pages.siteDetail.siteDocuments.deleteConfirm': '确定要删除这个文档吗？',
  'pages.siteDetail.siteDocuments.deleteSuccess': '文档删除成功',
  'pages.siteDetail.siteDocuments.createSuccess': '文档上传成功',
  'pages.siteDetail.siteDocuments.updateSuccess': '文档更新成功',
  'pages.siteDetail.siteDocuments.downloadSuccess': '文档下载已开始',
  'pages.siteDetail.siteDocuments.documentType.license': '许可证',
  'pages.siteDetail.siteDocuments.documentType.contract': '合同',
  'pages.siteDetail.siteDocuments.documentType.permit': '许可证',
  'pages.siteDetail.siteDocuments.documentType.certificate': '证书',
  'pages.siteDetail.siteDocuments.documentType.managementCompany': '管理公司',
  'pages.siteDetail.siteDocuments.documentType.publicLiabilityInsurance': '大厦公众责任保险',
  'pages.siteDetail.siteDocuments.documentType.propertyAllRisksInsurance': '大厦财产全险',
  'pages.siteDetail.siteDocuments.documentType.thirdPartyLiabilityInsurance': '大厦第三者责任保险',
  'pages.siteDetail.siteDocuments.documentType.fireInsurance': '大厦火保险',
  'pages.siteDetail.siteDocuments.documentType.workersCompensationInsurance': '大厦劳工保险',
  'pages.siteDetail.siteDocuments.documentType.elevatorMaintenance': '升降机保养',
  'pages.siteDetail.siteDocuments.documentType.elevatorLicense': '升降机行车证',
  'pages.siteDetail.siteDocuments.documentType.fireSafetyAnnualInspection': '消防年检',
  'pages.siteDetail.siteDocuments.documentType.cleaningCompanyContract': '清洁公司合约',
  'pages.siteDetail.siteDocuments.documentType.fireAlarmCompany': '消防設備供應商',
  'pages.siteDetail.siteDocuments.documentType.cctvMaintenance': '闭路电视监察系统保养',
  'pages.siteDetail.siteDocuments.documentType.freshWaterTankCleaning': '食水缸清洗',
  'pages.siteDetail.siteDocuments.documentType.saltWaterTankCleaning': '咸水缸清洗',
  'pages.siteDetail.siteDocuments.documentType.fireTankCleaning': '消防缸清洗',
  'pages.siteDetail.siteDocuments.documentType.fiveYearElectricalTest': '五年固定电力测试(WR2)',
  'pages.siteDetail.siteDocuments.documentType.governmentOrder': '政府命令',
  'pages.siteDetail.siteDocuments.documentType.meetingMinutes': '會議記錄',
  'pages.siteDetail.siteDocuments.documentType.expenseReport': '開支表',
  'pages.siteDetail.siteDocuments.documentType.managementFeeReport': '管理費報表',
  'pages.siteDetail.siteDocuments.documentType.emergencyNotice': '緊急通告',
  'pages.siteDetail.siteDocuments.documentType.importantNotes': '注意事項',
  'pages.siteDetail.siteDocuments.documentType.other': '其他',
  'pages.siteDetail.siteDocuments.attachment': '附件',
  'pages.siteDetail.siteDocuments.noAttachment': '无附件',

  // 站点文件管理页面
  'siteDocumentManagement.fetchSitesError': '获取物业列表失败',
  'siteDocumentManagement.fetchDocumentTypesError': '获取文件类型失败',
  'siteDocumentManagement.deleteSuccess': '文件删除成功',
  'siteDocumentManagement.deleteError': '删除文件失败',
  'siteDocumentManagement.noAttachment': '没有可下载的附件',
  'siteDocumentManagement.downloadError': '下载文件失败',
  'siteDocumentManagement.title': '标题',
  'siteDocumentManagement.site': '物业',
  'siteDocumentManagement.documentType': '文件类型',
  'siteDocumentManagement.expiryDate': '到期日期',
  'siteDocumentManagement.noExpiry': '无到期日',
  'siteDocumentManagement.status': '状态',
  'siteDocumentManagement.active': '启用',
  'siteDocumentManagement.inactive': '停用',
  'siteDocumentManagement.public': '公开',
  'siteDocumentManagement.private': '私有',
  'siteDocumentManagement.expired': '已过期',
  'siteDocumentManagement.createdAt': '创建时间',
  'siteDocumentManagement.updatedAt': '更新时间',
  'siteDocumentManagement.actions': '操作',
  'siteDocumentManagement.download': '下载',
  'siteDocumentManagement.downloadAction': '下载',
  'siteDocumentManagement.deleteConfirmTitle': '确定删除此文件？',
  'siteDocumentManagement.yes': '是',
  'siteDocumentManagement.no': '否',
  'siteDocumentManagement.delete': '删除',
  'siteDocumentManagement.export': '导出Excel',
  'siteDocumentManagement.exportSuccess': '导出任务已开始',
  'siteDocumentManagement.exportError': '导出文件失败',
  'siteDocumentManagement.search': '搜索',
  'siteDocumentManagement.searchPlaceholder': '按标题或描述搜索',
  'siteDocumentManagement.activeFilter': '启用',
  'siteDocumentManagement.publicFilter': '公开',
  'siteDocumentManagement.expiredFilter': '已过期',
  'siteDocumentManagement.expiringSoonFilter': '即将到期',
  'siteDocumentManagement.titlePage': '物业文件管理',
  'siteDocumentManagement.tableTitle': '物业文件',
  'siteDocumentManagement.refresh': '刷新',
  // Patrol Route Management
  'pages.siteDetail.patrolRouteManagementTitle': '巡逻路线',
  'pages.siteDetail.addPatrolRoute': '添加巡逻路线',
  'pages.siteDetail.editPatrolRoute': '编辑巡逻路线',
  'pages.siteDetail.deletePatrolRoute': '删除巡逻路线',
  'pages.siteDetail.patrolRouteName': '路线名称',
  'pages.siteDetail.patrolRouteDescription': '描述',
  'pages.siteDetail.daysEnabled': '启用日期',
  'pages.siteDetail.monday': '星期一',
  'pages.siteDetail.tuesday': '星期二',
  'pages.siteDetail.wednesday': '星期三',
  'pages.siteDetail.thursday': '星期四',
  'pages.siteDetail.friday': '星期五',
  'pages.siteDetail.saturday': '星期六',
  'pages.siteDetail.sunday': '星期日',
  'pages.siteDetail.manageCheckpoints': '管理检查点',
  'pages.siteDetail.patrolRouteCreated': '巡邏路線創建成功',
  'pages.siteDetail.patrolRouteUpdated': '巡邏路線更新成功',
  'pages.siteDetail.patrolRouteDeleted': '巡邏路線刪除成功',
  'pages.siteDetail.confirmDeletePatrolRoute': '您確定要刪除此巡邏路線嗎？',
  'pages.siteDetail.confirmDeletePatrolRouteTitle': '刪除巡邏路線',
  // 住戶管理
  'tenantManagement.title': '住戶管理',
  'tenantManagement.content': '管理系統住戶及其信息',
  'tenantManagement.tenantList': '住戶列表',
  'tenantManagement.createNewTenant': '創建新住戶',
  'tenantManagement.createTenant': '創建住戶',
  'tenantManagement.editTenant': '編輯住戶',
  'tenantManagement.deleteTenant': '刪除住戶',
  'tenantManagement.viewTenant': '查看住戶',
  'tenantManagement.tenantCreated': '住戶創建成功',
  'tenantManagement.tenantUpdated': '住戶更新成功',
  'tenantManagement.tenantDeleted': '住戶刪除成功',
  'tenantManagement.saveTenantFailed': '保存住戶失敗',
  'tenantManagement.deleteTenantFailed': '刪除住戶失敗',
  'tenantManagement.fetchSitesFailed': '獲取物業失敗',
  'tenantManagement.userAccountCreated': '用戶帳戶已創建，請保存憑證。',
  'tenantManagement.accessDenied': '訪問被拒絕',
  // 住戶表單字段
  'tenantManagement.name': '姓名',
  'tenantManagement.searchName': '按姓名搜索',
  'tenantManagement.pleaseInputName': '請輸入住戶姓名',
  'tenantManagement.email': '電子郵件',
  'tenantManagement.searchEmail': '按電子郵件搜索',
  'tenantManagement.pleaseInputEmail': '請輸入電子郵件',
  'tenantManagement.pleaseInputValidEmail': '請輸入有效的電子郵件',
  'tenantManagement.phone': '電話',
  'tenantManagement.searchPhone': '按電話搜索',
  'tenantManagement.pleaseInputPhone': '請輸入電話號碼',
  'tenantManagement.leaseStart': '租約開始',
  'tenantManagement.leaseStartDate': '租約開始日期',
  'tenantManagement.pleaseInputLeaseStart': '請輸入租約開始日期',
  'tenantManagement.leaseEnd': '租約結束',
  'tenantManagement.leaseEndDate': '租約結束日期',
  'tenantManagement.monthlyRent': '月租金',
  'tenantManagement.depositAmount': '押金金額',
  'tenantManagement.emergencyContactName': '緊急聯繫人姓名',
  'tenantManagement.emergencyContactPhone': '緊急聯繫人電話',
  'tenantManagement.notes': '備註',
  'tenantManagement.units': '單位',
  'tenantManagement.assignUnits': '分配單位',
  'tenantManagement.selectUnits': '選擇要分配的單位',
  'tenantManagement.status': '狀態',
  'tenantManagement.active': '活躍',
  'tenantManagement.inactive': '非活躍',
  'tenantManagement.createdAt': '創建時間',
  'tenantManagement.actions': '操作',
  // 住戶模態框
  'tenantManagement.delete': '刪除',
  'tenantManagement.cancel': '取消',
  'tenantManagement.deleteConfirmation': '您確定要刪除此住戶嗎？此操作無法撤銷。',
  'tenantManagement.userAccountCreatedTitle': '用戶帳戶已創建：',

  // Site Event Calendar
  'pages.siteDetail.eventCalendar.title': '物業事件日历',
  'pages.siteDetail.eventCalendar.addEvent': '添加事件',
  'pages.siteDetail.eventCalendar.createEvent': '创建事件',
  'pages.siteDetail.eventCalendar.editEvent': '编辑事件',
  'pages.siteDetail.eventCalendar.deleteEvent': '删除事件',
  'pages.siteDetail.eventCalendar.deleteConfirm': '确定要删除这个事件吗？',
  'pages.siteDetail.eventCalendar.delete': '删除事件',
  'pages.siteDetail.eventCalendar.deleteSuccess': '事件删除成功',
  'pages.siteDetail.eventCalendar.createSuccess': '事件创建成功',
  'pages.siteDetail.eventCalendar.updateSuccess': '事件更新成功',
  'pages.siteDetail.eventCalendar.operationFailed': '操作失败',
  'pages.siteDetail.eventCalendar.fetchFailed': '获取事件失败',

  // Event Form Fields
  'pages.siteDetail.eventCalendar.form.title': '标题',
  'pages.siteDetail.eventCalendar.form.titlePlaceholder': '输入事件标题',
  'pages.siteDetail.eventCalendar.form.titleRequired': '标题是必填项',
  'pages.siteDetail.eventCalendar.form.description': '描述',
  'pages.siteDetail.eventCalendar.form.descriptionPlaceholder': '输入事件描述',
  'pages.siteDetail.eventCalendar.form.eventType': '事件类型',
  'pages.siteDetail.eventCalendar.form.eventTypePlaceholder': '选择事件类型',
  'pages.siteDetail.eventCalendar.form.eventTypeRequired': '事件类型是必填项',
  'pages.siteDetail.eventCalendar.form.startDate': '开始日期',
  'pages.siteDetail.eventCalendar.form.startDatePlaceholder': '选择开始日期',
  'pages.siteDetail.eventCalendar.form.startDateRequired': '开始日期是必填项',
  'pages.siteDetail.eventCalendar.form.endDate': '结束日期',
  'pages.siteDetail.eventCalendar.form.endDatePlaceholder': '选择结束日期',
  'pages.siteDetail.eventCalendar.form.endDateRequired': '结束日期是必填项',
  'pages.siteDetail.eventCalendar.form.fullDay': '全天事件',
  'pages.siteDetail.eventCalendar.form.startTime': '开始时间',
  'pages.siteDetail.eventCalendar.form.startTimePlaceholder': '选择开始时间',
  'pages.siteDetail.eventCalendar.form.endTime': '结束时间',
  'pages.siteDetail.eventCalendar.form.endTimePlaceholder': '选择结束时间',
  'pages.siteDetail.eventCalendar.form.location': '地点',
  'pages.siteDetail.eventCalendar.form.locationPlaceholder': '输入事件地点',
  'pages.siteDetail.eventCalendar.form.color': '颜色',
  'pages.siteDetail.eventCalendar.form.priority': '优先级',
  'pages.siteDetail.eventCalendar.form.priorityPlaceholder': '选择优先级',
  'pages.siteDetail.eventCalendar.form.status': '状态',
  'pages.siteDetail.eventCalendar.form.statusPlaceholder': '选择状态',
  'pages.siteDetail.eventCalendar.form.assignedTo': '分配给',
  'pages.siteDetail.eventCalendar.form.assignedToPlaceholder': '选择分配的员工',
  'pages.siteDetail.eventCalendar.form.isPublic': '公开事件',
  'pages.siteDetail.eventCalendar.form.isActive': '激活',
  'pages.siteDetail.eventCalendar.form.isRecurring': '重复',
  'pages.siteDetail.eventCalendar.form.recurrenceRule': '重复规则',
  'pages.siteDetail.eventCalendar.form.recurrenceRulePlaceholder': '例如：FREQ=MONTHLY;INTERVAL=1',

  // Event Types
  'pages.siteDetail.eventCalendar.eventType.maintenance': '维护',
  'pages.siteDetail.eventCalendar.eventType.inspection': '检查',
  'pages.siteDetail.eventCalendar.eventType.visit': '访问',
  'pages.siteDetail.eventCalendar.eventType.holiday': '假期',
  'pages.siteDetail.eventCalendar.eventType.custom': '自定义',

  // Priority Levels
  'pages.siteDetail.eventCalendar.priority.low': '低',
  'pages.siteDetail.eventCalendar.priority.normal': '普通',
  'pages.siteDetail.eventCalendar.priority.high': '高',
  'pages.siteDetail.eventCalendar.priority.urgent': '紧急',

  // Event Statuses
  'pages.siteDetail.eventCalendar.status.scheduled': '已安排',
  'pages.siteDetail.eventCalendar.status.inProgress': '进行中',
  'pages.siteDetail.eventCalendar.status.completed': '已完成',
  'pages.siteDetail.eventCalendar.status.cancelled': '已取消',

  // Transaction Detail Modal
  'transaction.details': '详细信息',
  'transaction.viewDetails': '查看详细信息',
  'transaction.detailTitle': '交易详细信息',
  'transaction.close': '关闭',
  'transaction.openFullSize': '打开全尺寸',
  'transaction.viewImage': '查看图片',
  'transaction.approve': '批准',
  'transaction.reject': '拒绝',
  'transaction.cancel': '取消',
  'transaction.approveSuccess': '交易批准成功',
  'transaction.rejectSuccess': '交易拒绝成功',
  'transaction.cancelSuccess': '交易取消成功',
  'transaction.confirmApproveTitle': '确认批准',
  'transaction.confirmApproveContent': '您确定要批准此交易吗？此操作无法撤销。',
  'transaction.confirmRejectTitle': '确认拒绝',
  'transaction.confirmRejectContent': '您确定要拒绝此交易吗？此操作无法撤销。',
  'transaction.confirmCancelTitle': '确认取消',
  'transaction.confirmCancelContent': '您确定要取消此交易吗？此操作无法撤销。',
  'transaction.transactionDetails': '交易详情',
  'transaction.noDescription': '无描述',
  'transaction.cancelAction': '取消',
  'occurrenceBook.title': 'ob簿',
  'occurrenceBookRecord.title': 'ob簿記錄',
  'unitModal.unitNumber': '单位编号',
  'patrolRoute.modalTitle': '巡逻路线',
  'patrolRoute.name': '路线名称',
  'patrolRoute.nameRequired': '路线名称必填',
  'patrolRoute.namePlaceholder': '请输入路线名称',
  'patrolRoute.description': '描述',
  'patrolRoute.descriptionPlaceholder': '请输入描述',
  'patrolRoute.daysEnabled': '启用天数',
  'patrolRoute.monday': '星期一',
  'patrolRoute.tuesday': '星期二',
  'patrolRoute.wednesday': '星期三',
  'patrolRoute.thursday': '星期四',
  'patrolRoute.friday': '星期五',
  'patrolRoute.saturday': '星期六',
  'patrolRoute.sunday': '星期日',
  'patrolRoute.sequence': '顺序',
  'patrolRoute.checkpoint': '检查点',
  'patrolRoute.referenceCode': '参考代码',
  'patrolRoute.expectedTime': '预期时间',
  'patrolRoute.tolerance': '容差',
  'patrolRoute.required': '必填',
  'patrolRoute.notes': '备注',
  'patrolRoute.action': '操作',
  'patrolRoute.checkpointsTitle': '检查点',
  'patrolRoute.addCheckpoint': '新增检查点',
  'patrolRoute.checkpointModalTitle': '检查点详情',
  'patrolRoute.checkpointRequired': '检查点必填',
  'patrolRoute.selectCheckpoint': '选择检查点',
  'patrolRoute.expectedTimeRequired': '预期时间必填',
  'siteDetail.addDevice': '新增设备',
  'siteDetail.deviceName': '设备名称',
  'siteDetail.deviceNameRequired': '设备名称必填',
  'siteDetail.deviceType': '设备类型',
  'siteDetail.deviceTypeRequired': '设备类型必填',
  'siteDetail.deviceModel': '设备型号',
  'siteDetail.deviceSerial': '设备序号',
  'siteDetail.macAddress': 'MAC地址',
  'siteDetail.ipAddress': 'IP地址',
  'siteDetail.locationDescription': '位置描述',
  'siteDetail.floorLevel': '楼层',
  'siteDetail.zoneArea': '区域',
  'siteDetail.username': '用户名',
  'siteDetail.usernameRequired': '用户名必填',
  'siteDetail.email': '电子邮件',
  'siteDetail.emailRequired': '电子邮件必填',
  'siteDetail.password': '密码',
  'siteDetail.passwordRequired': '密码必填',
  'siteDetail.autoLogin': '自动登录',
  'siteDetail.offlineMode': '离线模式',
  'siteDetail.syncInterval': '同步间隔',
  'siteDetail.installationDate': '安装日期',
  'siteDetail.warrantyExpiry': '保修到期',
  'siteDetail.maintenanceSchedule': '维护计划',
  'siteDetail.notes': '备注',
  'siteDetail.installationNotes': '安装备注',
  'siteDetail.troubleshootingNotes': '故障排除备注',
  'siteDetail.deviceStatus': '设备状态',
  'siteDetail.accessLevel': '访问等级',
  'siteDetail.authToken': '认证令牌',
  'siteDetail.lastHeartbeat': '最后心跳',
  'siteDetail.actions': '操作',
  'siteDetail.incidentManagement': '事件管理',
  'siteDetail.patrolRouteManagementTitle': '巡逻路线管理',
  'siteDetail.daysEnabled': '启用天数',
  'siteDetail.deviceManagement': '设备管理',
  'siteDetail.startTime': '开始时间',
  'siteDetail.endTime': '结束时间',
  'occurrenceBook.new': '新增ob簿',
  'occurrenceBook.edit': '编辑ob簿',
  'occurrenceBook.id': '编号',
  'occurrenceBook.checkpoint': '检查点',
  'occurrenceBook.expectedTime': '预期时间',
  'occurrenceBook.assignedAt': '预期时间',
  'occurrenceBook.action': '操作',
  'occurrenceBook.shift': '班次',
  'occurrenceBook.selectCheckpoint': '选择检查点',
  'occurrenceBook.selectShift': '选择班次',
  'occurrenceBook.tolerance': '容差（分钟）',
  'occurrenceBook.failedToFetch': '获取ob簿失败',
  'occurrenceBook.deleted': '已删除',
  'occurrenceBook.updated': '已更新',
  'occurrenceBook.created': '已创建',
  'occurrenceBookRecord.new': '新增ob簿记录',
  'occurrenceBookRecord.edit': '编辑ob簿记录',
  'occurrenceBookRecord.id': '编号',
  'occurrenceBookRecord.obNumber': 'OB编号',
  'occurrenceBookRecord.expectedTime': '预期时间',
  'occurrenceBookRecord.checkpoint': '检查点',
  'occurrenceBookRecord.attendanceTimestamp': '考勤时间戳',
  'occurrenceBookRecord.action': '操作',
  'occurrenceBookRecord.occurrenceBook': 'ob簿',
  'occurrenceBookRecord.selectOccurrenceBook': '选择ob簿',
  'occurrenceBookRecord.staff': '员工',
  'occurrenceBookRecord.selectStaff': '选择员工',
  'occurrenceBookRecord.selectCheckpoint': '选择检查点',
  'occurrenceBookRecord.approved': '已批准',
  'occurrenceBookRecord.timestamp': '时间戳',
  'occurrenceBookRecord.failedToFetch': '获取ob簿记录失败',
  'occurrenceBookRecord.deleted': '已删除',
  'occurrenceBookRecord.updated': '已更新',
  'occurrenceBookRecord.created': '已创建',
  'occurrenceBookRecord.dateRange': '日期范围',
  'occurrenceBookRecord.selectApprovalStatus': '全部',
  'occurrenceBookRecord.notApproved': '未批准',
  'occurrenceBookRecord.filter': '筛选',
  'occurrenceBookRecord.reset': '重置',

  // Public Holiday Management
  'holidayManagement.title': '公共假期管理',
  'holidayManagement.content': '管理组织的公共假期',
  'holidayManagement.holidayList': '假期列表',
  'holidayManagement.addNewHoliday': '添加新假期',
  'holidayManagement.editHoliday': '编辑假期',
  'holidayManagement.addHoliday': '添加假期',
  'holidayManagement.createSuccess': '假期创建成功',
  'holidayManagement.updateSuccess': '假期更新成功',
  'holidayManagement.deleteSuccess': '假期删除成功',
  'holidayManagement.deleteFailed': '删除失败',
  'holidayManagement.operationFailed': '操作失败',
  'holidayManagement.deleteConfirm': '您确定要删除这个假期吗？',
  'holidayManagement.name': '假期名称',
  'holidayManagement.description': '描述',
  'holidayManagement.date': '日期',
  'holidayManagement.countryCode': '国家',
  'holidayManagement.stateCode': '州/地区',
  'holidayManagement.isNational': '国家假期',
  'holidayManagement.status': '状态',
  'holidayManagement.action': '操作',
  'holidayManagement.edit': '编辑',
  'holidayManagement.delete': '删除',
  'holidayManagement.yes': '是',
  'holidayManagement.no': '否',
  'holidayManagement.active': '激活',
  'holidayManagement.inactive': '未激活',
  'holidayManagement.searchName': '搜索假期名称',
  'holidayManagement.searchDescription': '搜索描述',
  'holidayManagement.holidayName': '假期名称',
  'holidayManagement.pleaseEnterHolidayName': '请输入假期名称',
  'holidayManagement.pleaseSelectDate': '请选择日期',
  'holidayManagement.pleaseSelectCountry': '请选择国家',
  'holidayManagement.pleaseSelectState': '请选择州/地区',
  'holidayManagement.isActive': '激活',
  'holidayManagement.showing': '显示',
  'holidayManagement.of': '共',
  'holidayManagement.items': '项',

  // 香港公共假期名称
  'holidayManagement.holidayNames.newYearsDay': '元旦',
  'holidayManagement.holidayNames.lunarNewYearsDay': '农历新年',
  'holidayManagement.holidayNames.secondDayOfLunarNewYear': '农历新年第二天',
  'holidayManagement.holidayNames.thirdDayOfLunarNewYear': '农历新年第三天',
  'holidayManagement.holidayNames.chingMingFestival': '清明节',
  'holidayManagement.holidayNames.goodFriday': '耶稣受难节',
  'holidayManagement.holidayNames.dayFollowingGoodFriday': '耶稣受难节翌日',
  'holidayManagement.holidayNames.easterMonday': '复活节星期一',
  'holidayManagement.holidayNames.labourDay': '劳动节',
  'holidayManagement.holidayNames.buddhaBirthday': '佛诞',
  'holidayManagement.holidayNames.tuenNgFestival': '端午节',
  'holidayManagement.holidayNames.hkEstablishmentDay': '香港特别行政区成立纪念日',
  'holidayManagement.holidayNames.nationalDay': '国庆日',
  'holidayManagement.holidayNames.dayFollowingMidAutumn': '中秋节翌日',
  'holidayManagement.holidayNames.chungYeungFestival': '重阳节',
  'holidayManagement.holidayNames.christmasDay': '圣诞节',
  'holidayManagement.holidayNames.firstWeekdayAfterChristmas': '圣诞节后第一个周日',
  'holidayManagement.quickAddCommonHoliday': '快速添加常见假期',
  'holidayManagement.originalName': '原名',

  // Staff 468 Rule Tooltip
  'staff468Rule.loading': '正在加载工作时数...',
  'staff468Rule.error': '错误',
  'staff468Rule.noData': '暂无数据',
  'staff468Rule.workingHoursSummary': '工作时数摘要 (4周)',
  'staff468Rule.totalHours': '总时数:',
  'staff468Rule.threshold': '阈值:',
  'staff468Rule.extraHours': '超时:',
  'staff468Rule.exceedsRule': '⚠️ 超出468规则',
  'staff468Rule.withinRule': '✅ 符合468规则',
  'staff468Rule.holidayCompliance': '假期合规 (7天规则)',
  'staff468Rule.complianceRate': '合规率:',
  'staff468Rule.compliantPeriods': '合规期间:',
  'staff468Rule.violations': '违规:',
  'staff468Rule.holidayCompliant': '✅ 假期合规',
  'staff468Rule.holidayViolation': '⚠️ 假期违规',
  'staff468Rule.violationPeriods': '违规期间:',
  'staff468Rule.days': '天',
  'staff468Rule.moreViolations': '... 还有 {count} 个违规',
  'staff468Rule.calculationPeriod': '计算期间:',
  'staff468Rule.recentAssignments': '最近排班 ({count}):',
  'staff468Rule.moreAssignments': '... 还有 {count} 个排班',
  'staff468Rule.ruleViolation': '⚠️ 468规则违规',
  'staff468Rule.ruleViolationMessage':
    '此员工在过去4周内已超过68小时阈值。新排班可能需要额外批准。',
  'staff468Rule.holidayViolationTitle': '⚠️ 假期合规违规',
  'staff468Rule.holidayViolationMessage':
    '此员工在每7天期间内没有至少一天假期。请考虑安排休假或调整排班。',
  'staff468Rule.overnight': '通宵',
  'staff468Rule.staff': '员工:',

  // Shift Detail Tooltip Messages
  'shiftDetail.cannotAssignThreshold':
    '无法分配班次：员工已超过468规则阈值（4周内68小时）。需要额外批准。',
  'shiftDetail.cannotAssignHoliday':
    '无法分配班次：员工假期合规违规（7天期间内无假期）。请考虑安排休假或调整排班。',
  'shiftDetail.assignToThisShift': '分配到此班次',
  'shiftDetail.assignToOtherShift': '分配到其他班次',
  'shiftDetail.markAsLeave': '标记为休假',
  'shiftDetail.ruleAndHolidayViolated': ' (468规则和假期合规违规)',
  'shiftDetail.ruleExceeded': ' (468规则超出)',
  'shiftDetail.holidayViolated': ' (假期合规违规)',

  // Shift Detail Export
  'shiftDetail.exportExcel': '导出Excel',
  'shiftDetail.exportSuccess': '导出成功',
  'shiftDetail.exportError': '导出失败',

  // Staff Assignment Export
  'staffAssignment.backToShiftAssignment': '返回班次分配',
  'staffAssignment.viewShiftDetail': '查看班次详情',
  'staffAssignment.selectShiftForDetail': '选择要查看详情的班次',
  'staffAssignment.viewDetail': '查看详情',
  'staffAssignment.selectShiftMessage': '请选择您想要查看详情的班次：',
  'staffAssignment.site': '站点',
  'staffAssignment.selectSite': '选择站点',
  'staffAssignment.shift': '班次',
  'staffAssignment.selectShift': '选择班次',
  'staffAssignment.leaveType': '请假类型',
  'staffAssignment.reason': '原因',
  'staffAssignment.preferredShifts': '首选班次',
  'staffAssignment.clickForOptions': '点击查看选项',
  'staffAssignment.exportExcel': '导出Excel',
  'staffAssignment.exportSuccess': '导出成功',
  'staffAssignment.exportError': '导出失败',

  // Staff Assignment Additional Translations
  'staffAssignment.assignShift': '分配班次',
  'staffAssignment.assignLeave': '分配请假',
  'staffAssignment.editAssignment': '编辑排班',
  'staffAssignment.removeAssignment': '移除排班',
  'staffAssignment.updateLeave': '更新请假',
  'staffAssignment.deleteLeave': '删除请假',
  'staffAssignment.editLeave': '编辑请假',
  'staffAssignment.addLeave': '添加请假',
  'staffAssignment.deleteLeaveTitle': '删除请假',
  'staffAssignment.deleteLeaveMessage': '确定要删除此请假吗？',
  'staffAssignment.leaveDetails': '请假详情',
  'staffAssignment.delete': '删除',
  'staffAssignment.selectShiftPlaceholder': '选择班次',
  'staffAssignment.assignmentRemoved': '排班移除成功',
  'staffAssignment.assignmentRemoveFailed': '排班移除失败',
  'staffAssignment.leaveUpdated': '请假更新成功',
  'staffAssignment.leaveCreated': '请假创建成功',
  'staffAssignment.leaveProcessFailed': '请假处理失败',
  'staffAssignment.leaveDeleted': '请假删除成功',
  'staffAssignment.leaveDeleteFailed': '请假删除失败',
  'staffAssignment.manageLeave': '管理请假',
  'staffAssignment.assignShiftTitle': '分配班次',
  'staffAssignment.siteShift': '站点 - 班次',
  'staffAssignment.employeeId': '员工编号',
  'staffAssignment.phone': '电话',
  'staffAssignment.active': '在职',
  'staffAssignment.inactive': '离职',
  'staffAssignment.date': '日期',
  'staffAssignment.type': '类型',
  'staffAssignment.statutoryHoliday': '法定节假日',
  'staffAssignment.annualLeave': '年假',
  'staffAssignment.noPayLeave': '无薪假',
  'staffAssignment.regularHoliday': '例假',
  'staffAssignment.compensationLeave': '补假',
  'staffAssignment.absenceWithoutLeave': '旷工',
  'staffAssignment.sickLeave': '病假',
  'staffAssignment.unpaidSickLeave': '无薪病假',

  // Attendance Management Export
  'attendance.exportExcel': '导出Excel',
  'attendance.exportMonthly': '导出月度考勤',
  'attendance.exportSuccess': '考勤数据导出成功',
  'attendance.exportError': '考勤数据导出失败',
  'attendance.exportTooltip': '导出月度考勤记录到Excel文件',
  'attendance.selectMonth': '选择导出月份',

  // Version Management
  'versionManagement.title': '应用版本管理',
  'versionManagement.versionList': '版本列表',
  'versionManagement.createVersion': '创建版本',
  'versionManagement.editVersion': '编辑版本',
  'versionManagement.versionDetail': '版本详情',
  'versionManagement.versionNumber': '版本号',
  'versionManagement.versionName': '版本名称',
  'versionManagement.platform': '平台',
  'versionManagement.releaseType': '发布类型',
  'versionManagement.status': '状态',
  'versionManagement.releaseSummary': '发布摘要',
  'versionManagement.releaseNotes': '发布说明',
  'versionManagement.features': '新功能',
  'versionManagement.bugFixes': '错误修复',
  'versionManagement.improvements': '改进',
  'versionManagement.breakingChanges': '破坏性变更',
  'versionManagement.minOsVersion': '最低系统版本',
  'versionManagement.maxOsVersion': '最高系统版本',
  'versionManagement.plannedReleaseDate': '计划发布日期',
  'versionManagement.forceUpdate': '强制更新',
  'versionManagement.critical': '关键',
  'versionManagement.active': '激活',
  'versionManagement.inactive': '未激活',
  'versionManagement.buildNumber': '构建号',
  'versionManagement.fileInfo': '文件信息',
  'versionManagement.viewFileInfo': '查看文件信息',
  'versionManagement.downloadFile': '下载文件',
  'versionManagement.flags': '标志',
  'versionManagement.createdAt': '创建时间',
  'versionManagement.updatedAt': '更新时间',
  'versionManagement.actions': '操作',
  'versionManagement.edit': '编辑',
  'versionManagement.detail': '详情',
  'versionManagement.approve': '批准',
  'versionManagement.release': '发布',
  'versionManagement.deprecate': '弃用',
  'versionManagement.approveConfirm': '确定要批准此版本吗？',
  'versionManagement.releaseConfirm': '确定要发布此版本吗？',
  'versionManagement.deprecateConfirm': '确定要弃用此版本吗？',
  'versionManagement.createSuccess': '版本创建成功',
  'versionManagement.createError': '版本创建失败',
  'versionManagement.updateSuccess': '版本更新成功',
  'versionManagement.updateError': '版本更新失败',
  'versionManagement.approveSuccess': '版本批准成功',
  'versionManagement.approveError': '版本批准失败',
  'versionManagement.releaseSuccess': '版本发布成功',
  'versionManagement.releaseError': '版本发布失败',
  'versionManagement.deprecateSuccess': '版本弃用成功',
  'versionManagement.deprecateError': '版本弃用失败',
  'versionManagement.downloadSuccess': '文件下载成功',
  'versionManagement.downloadError': '文件下载失败',
  'versionManagement.uploadSuccess': '文件上传成功',
  'versionManagement.uploadError': '文件上传失败',
  'versionManagement.removeFileSuccess': '文件删除成功',
  'versionManagement.removeFileError': '文件删除失败',
  'versionManagement.getFileInfoError': '获取文件信息失败',
  'versionManagement.basicInfo': '基本信息',
  'versionManagement.timestamps': '时间戳',
  'versionManagement.releaseDate': '发布日期',
  'versionManagement.osRequirements': '系统要求',
  'versionManagement.filename': '文件名',
  'versionManagement.fileSize': '文件大小',
  'versionManagement.checksum': '校验和',
  'versionManagement.uploadedAt': '上传时间',
  'versionManagement.uploadedBy': '上传者',
  'versionManagement.noFileAttached': '此版本未附加文件',
  'versionManagement.uploadFile': '上传文件',
  'versionManagement.removeFile': '删除文件',
  'versionManagement.removeFileConfirm': '确定要删除此文件吗？',
  'versionManagement.versionNumberRequired': '请输入版本号',
  'versionManagement.platformRequired': '请选择平台',
  'versionManagement.releaseTypeRequired': '请选择发布类型',
  'versionManagement.appFile': '应用文件（可选）',
  'versionManagement.fileUploadHelp': '上传此版本的应用文件（APK、IPA、ZIP等）',
  'versionManagement.selectFile': '选择文件',
  'versionManagement.selectedFile': '已选择文件',
};
